import { render } from "./LearningPlanPage.vue?vue&type=template&id=21cb2a17"
import script from "./LearningPlanPage.vue?vue&type=script&lang=js"
export * from "./LearningPlanPage.vue?vue&type=script&lang=js"

import "./LearningPlanPage.vue?vue&type=style&index=0&id=21cb2a17&lang=sass"

import exportComponent from "../../../../../../opt/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__